export interface ConnectionFormData {
  certificate: string;
  signInUrl: string;
  logoutUrl: string;
  domains?: string[];
}

export const formDataToConnection = (formData: ConnectionFormData) => {
  return {
    auth0_certificate: formData.certificate,
    auth0_sign_in_endpoint: formData.signInUrl,
    auth0_sign_out_endpoint: formData.logoutUrl,
    ...(formData.domains && { auth0_domain_aliases: formData.domains }),
  };
};
